import { BodyPartGroupName, BodyPartName } from '../body-parts';
import { HotkeyModelMap } from '../hotkeys';

export interface ModelConfigParams {
  readonly bodyParts: readonly (BodyPartName | BodyPartGroupName)[]
  readonly checklist: readonly string[] // Manufacturing (MFG) checklist
  readonly checklistQC: readonly string[] // Quality Control (QC) checklist
  readonly defaultIntensityRange: readonly [number, number]
  readonly internal?: true // internal ModelTypes cannot be created by clinicians in Diary
  readonly tissueHotkeys?: HotkeyModelMap
}

// any checklist items by more than one ModelType
export const genericStartQC =   [
  "Volume - QC automatic scoring has been checked and, if needed, an appropriate warning will be added before publication.",
  "Case notes - have been clearly addressed in the manufacturing process",
]

export const genericEnd =   [
  "Connected components - has been run, and all loose components have been checked and removed",
  "3D model - contains all model components, each component performs and functions as intended"
]

export const genericApplicationChecklistMFG = [
  [
  "Tumour boundary - accurate in all views [axial/saggital/coronal]",
  "Relevant organs - included and accurate in all views [axial/saggital/coronal]",
  "Vessels - all are connected",
  ],
  genericEnd,
].flat()

export const genericApplicationChecklistQC = [
  genericStartQC,
  genericApplicationChecklistMFG
].flat()

export const lungChecklistMFG = [
  [
    "Lobes are complete, correctly labelled, and fissures are accurate",
    "Lobe segments are present and seeded correctly [segmentectomy]",
    "Artery main branches are labelled and correct",
    "Vein main branches are labelled and correct",
    "Artery/vein cross overs are correct",
    "Tumour boundary is not confused with scar tissue",
  ],
  genericEnd,
].flat()

export const lungChecklistQC = [
  genericStartQC,
  [
    "Lobes - all are identified and correctly labelled and fissures separating the lobes are clearly defined", 
    "Airway - all are identified, correctly labelled and connected to the trachea",
    "Arteries - all visible arteries are identified, correctly labelled and connected to the pulmonary artery",
    "Veins - all visible veins are identified, correctly labelled and connected to the pulmonary veins",
    "Lesions (Nodule/GGO) - all are identified and correctly labelled according to the information provided in the case notes", 
    "Lobe to segments - If required by the customer, the lobe partitioner been run and do the segments conform to the standard classification",
    "Sub-segments - If required by the customer, the lobe partitioner been run to include sub-segments (e.g S1a + S1b) in the location of the tumour and do the segments conform to the standard classification",
  ],
  genericEnd,
].flat()

export const kidneyChecklistQC = [
  genericStartQC,
  [
  "Renal vessels - all renal arteries and veins have been identified and correctly labelled. No renal vessels have been missed",
  "Hilar vessels - all visible hilar arteries and veins have been correctly identified and labelled. No hilar vessels have been missed",
  "Collecting system - has been identified and labelled correctly. All visible calyx are connected to the PUJ and ureter",
  "Ureter and gonadal vessels - have been identified and labelled correctly",
  "Cysts - have been identified and labelled correctly",
  "Lesions (tumours/cysts) - all lesions have been identified and correctly labelled according to the case notes",
  ],
  genericEnd,
].flat()